import { useMemo } from 'react'
import ReactLightbox from 'yet-another-react-lightbox'
import Counter from 'yet-another-react-lightbox/plugins/counter'

import { Icon } from '@/shared/ui'

import { Slide } from './slide'

import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/counter.css'

type Props = {
  index: number
  onClose: () => void
  images: string[]
  roomName: string
}

export const MobileLightbox = ({ index, onClose, images, roomName }: Props) => {
  const isOpen = index >= 0

  const slides = useMemo(() => {
    return images.map(image => ({
      src: image,
    }))
  }, [images])

  return (
    <ReactLightbox
      open={isOpen}
      close={onClose}
      index={index}
      slides={slides}
      className="pointer-events-auto"
      plugins={[Counter]}
      render={{
        slide: props => (
          <Slide {...props} roomName={roomName} className="max-w-full" />
        ),
        iconPrev: () => null,
        iconNext: () => null,
        iconClose: () => (
          <Icon name="arrow-left" size={24} className="text-white" />
        ),
      }}
      styles={{
        slide: {
          padding: 0,
        },
        toolbar: {
          left: 0,
          right: 'unset',
        },
      }}
      counter={{
        container: {
          style: { top: '0', left: 'unset', right: '0', margin: '4px 8px' },
          className: 'typo-label2',
        },
      }}
    />
  )
}
